import React, { Suspense, lazy } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { css } from '@emotion/react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import Tab from '@components/Common/Tab';
import PortfolioHeaderSkeleton from '@components/Group/Portfolio/Skeleton/PortfolioHeaderSkeleton';

import { usePortfolioDetail } from '@hooks/query/usePortfolioDetail';

const PortfolioHeader = lazy(
  () => import('@components/Group/Portfolio/PortfolioHeader')
);

/** 조합 관리 > 상세 > 포트폴리오 > 상세 */
const Portfolio = () => {
  const { groupId, portfolioId } = useParams();
  const { data } = usePortfolioDetail();

  const TAB_OPTIONS = [
    {
      label: '기본정보',
      href: `/group/${groupId}/portfolio/${portfolioId}/basic-info`,
    },
    {
      label: '투자유치이력',
      href: `/group/${groupId}/portfolio/${portfolioId}/invest-history`,
    },
    {
      label: '주주 현황',
      href: `/group/${groupId}/portfolio/${portfolioId}/stockholder`,
    },
    {
      label: '자본금 변동내역',
      href: `/group/${groupId}/portfolio/${portfolioId}/capital-change`,
    },
    {
      label: '성장정보',
      href: `/group/${groupId}/portfolio/${portfolioId}/growth-info`,
    },
    // {
    //   label: '현금흐름',
    //   href: `/group/${groupId}/portfolio/${portfolioId}/cashflow`,
    // },
    {
      label: '주요거래처',
      href: `/group/${groupId}/portfolio/${portfolioId}/customer`,
    },
    {
      label: '손익재무',
      href: `/group/${groupId}/portfolio/${portfolioId}/finance`,
    },
    {
      label: '투자자산관리',
      href: `/group/${groupId}/portfolio/${portfolioId}/invest-asset`,
    },
    {
      label: '사후관리',
      href: `/group/${groupId}/portfolio/${portfolioId}/post-management`,
    },
    {
      label: '보도자료',
      href: `/group/${groupId}/portfolio/${portfolioId}/press`,
    },
  ];

  return (
    <div css={container}>
      <ApiErrorBoundary>
        <Suspense fallback={<PortfolioHeaderSkeleton />}>
          <PortfolioHeader />
        </Suspense>
      </ApiErrorBoundary>
      <Tab options={TAB_OPTIONS} />
      <div css={subContainer}>
        <div className="wrap">
          <Outlet context={{ portfolioData: data || null }} />
        </div>
      </div>
    </div>
  );
};

export default Portfolio;

const container = css`
  padding-top: 30px;
`;

const subContainer = css`
  width: calc(100vw - 250px);
  height: calc(100vh - 135px);
  overflow-x: hidden;
  overflow-y: auto;
  .wrap {
    min-width: calc(1200px - 250px);
    max-width: calc(1920px - 250px);
    width: 100%;
    padding: 30px 40px;
  }
`;
